module.exports = __webpack_public_path__ + "static/media/4ODA6.0fa0f260.jpg";